export interface StepLabelProps {
  index: number;
  label: string;
  complete: boolean;
}

export default function StepLabel({ index, label, complete }: StepLabelProps) {
  return (
    <span className="sendin-step-label">
      <span className="sendin-step-number">{complete ? "✓" : index + 1}</span>
      {label}
    </span>
  );
}
